import React from "react";
import ListItem from "../../components/ListItem";
import Link from "../../components/Link";
import Image from "../../components/Image";
import Name from "../../components/Name";
import { TopperItem } from "../../../../types";

/**
 * This variant represents display type 4
 * @param url
 * @param itemId
 * @param image
 * @param name
 */
const ImageAndTitle = ({
  url,
  itemId,
  image,
  name,
  itemIndex
}: TopperItem) => <ListItem itemIndex={itemIndex} data-sentry-element="ListItem" data-sentry-component="ImageAndTitle" data-sentry-source-file="index.tsx">
    <Link className="flex-col min-w-[100px] mt-1" href={url} title={name} data-testid={`topper-item-${itemId}`} data-sentry-element="Link" data-sentry-source-file="index.tsx">
      <Image src={image} width="1" height="1" className="text-sm text-center h-20 w-20" loading="eager" alt="" data-sentry-element="Image" data-sentry-source-file="index.tsx" />
      <Name className="text-sm text-center w-min min-w-full" data-sentry-element="Name" data-sentry-source-file="index.tsx">{name}</Name>
    </Link>
  </ListItem>;
export default ImageAndTitle;